import { render, staticRenderFns } from "./index.vue?vue&type=template&id=df0bd556&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df0bd556",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2023/thShop/thShopAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df0bd556')) {
      api.createRecord('df0bd556', component.options)
    } else {
      api.reload('df0bd556', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=df0bd556&scoped=true&", function () {
      api.rerender('df0bd556', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/reports/summerStatic/index.vue"
export default component.exports